import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAwsRum, setRUMUser } from '../aws-rum'; // adjust this path as per your project
import { getToken } from '../services/api/login';

const useRUMRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const awsRum = getAwsRum();
    const verifyAccess = getToken();
          if(verifyAccess?.token){
            const userId=verifyAccess.responseData.email
              setRUMUser(userId, {
               currentPath: location.pathname,
             });
          }
    awsRum?.recordPageView({
      pageId:location.pathname,
      pageAttributes:{
        "pathname": location.pathname,
        "url": window.location.href
        }
    });
  }, [location]);
};

export default useRUMRouteTracker;